const apikey = {
  xapikey: "fylhvz5mOP1FroRvrVkiz1Q8YzW5KTmYaR8mf2Sv"
};

export default apikey;